import BaseModel from '../base/BaseModel.model';
import PorposalBudgetItem from './porposalBudgetItem.model';
import ProposalBudgetSubItemExecution from './proposalBudgetSubItemExecution.model';
import BudgetItemEvaluation from './budgetItemEvaluation.model';
export default class ProposalBudgetItemExecution extends BaseModel {

    public porposalBudgetItemId?: number | null;
    public porposalBudgetItem?: PorposalBudgetItem | null;
    public porposalUserReportId?: number | null;
    public amountSpent?: number | null;
    public totalAmountAccumulatedAbove?: number | null;
    public proposalBudgetSubItemsExecution: Array<ProposalBudgetSubItemExecution> = [];

    // UI
    public budgetItemEvaluationUI: BudgetItemEvaluation = new BudgetItemEvaluation();


    constructor() {
        super();
        this.init();
    }

    init() {
        this.porposalBudgetItemId = null;
        this.porposalBudgetItem = null;
        this.porposalUserReportId = null;

        this.amountSpent = 0;
        this.totalAmountAccumulatedAbove = null;
        this.proposalBudgetSubItemsExecution = [];
    }
}